module.exports = __webpack_public_path__ + "img/4.10bbcfe9.jpg";